import axios from 'axios';
import qs from 'qs';
import helpers from '../util/helpers';
import * as constants from '../util/constants';

export default {
  init() {
    // JavaScript to be fired on init
  },
  finalize() {
    // JavaScript to be fired on loaded

    // Offers
    const offersWrapper = $('#global-offers-wrapper');
    if (offersWrapper.length) {
      // Cancel token source
      let cancelTokenSource = null;

      const handleOffersResults = function(offset = 0) {
        // Cancel previous request if it exists
        if (cancelTokenSource) {
          cancelTokenSource.cancel('New request initiated, cancel previous.');
        }
        cancelTokenSource = axios.CancelToken.source();

        const countLabel = $('#global-offers-count-label');
        const skeleton = $('#global-offers-skeleton');
        const loadMoreButtonWrapper = $('#global-offers-load-more-button-wrapper');
        let page = parseInt(offersWrapper.data('page'), 10);
        const perPage = parseInt(offersWrapper.data('per-page'), 10);
        const params = helpers.getParameters();

        if (offset === 0) {
          countLabel.text('');
          offersWrapper.html('');
        }
        skeleton.show();
        loadMoreButtonWrapper.hide();

        // Params
        const data = {
          'action': constants.ACTION_GET_GLOBAL_OFFERS,
          'location': params['location'] || '',
          'type': params['offer-type'] || '',
          'offset': offset,
        };

        // Send request
        axios.post(window.Rydges['ajaxUrl'], qs.stringify(data), {
          cancelToken: cancelTokenSource.token,
        }).then((axiosResponse) => {
          if (200 === axiosResponse.status) {
            const response = axiosResponse.data;

            skeleton.hide();

            if (response.success) {
              const count = response.data['count'];
              const html = response.data['html'];

              if (html.length) {
                if (offset === 0) {
                  countLabel.text(`${count} offers`);
                  offersWrapper.html(html);
                  page = 1;
                  offset = perPage;
                } else {
                  offersWrapper.append(html);

                  // Increment page and offset
                  page += 1;
                  offset += perPage;
                }

                // Update attributes
                offersWrapper.data('page', page).attr('data-page', page);
                offersWrapper.data('offset', offset).attr('data-offset', offset);

                // Update URL
                params['page_number'] = page;
                helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

                // Equal height for elements
                $(document).trigger(constants.EVENT_BALANCE_ELEMENTS);

                if (offset >= count) {
                  loadMoreButtonWrapper.hide();
                } else {
                  loadMoreButtonWrapper.show();
                }
              } else {
                loadMoreButtonWrapper.hide();
              }
            } else {
              loadMoreButtonWrapper.hide();
            }
          }
        }).catch((error) => {
          console.log(error);
        });
      };

      const searchOffersForm = $('.search-offers');
      if (searchOffersForm.length) {
        const offerLocationsSearch = searchOffersForm.find('.where');
        const offerTypesSearch = searchOffersForm.find('.offers-search');
        const offerLocation = helpers.getParameterByName('location');
        const offerType = helpers.getParameterByName('offer-type');
        const offerLocationCookie = helpers.docCookies.getItem(constants.COOKIE_KEY_OFFERS_SEARCH_LOCATION);
        const offerTypeCookie = helpers.docCookies.getItem(constants.COOKIE_KEY_OFFERS_SEARCH_TYPE);
        const params = helpers.getParameters();

        // Set url params to cookie
        if (offerLocation != null && offerLocation.length) {
          params['location'] = offerLocation;
          offerLocationsSearch.val(offerLocation);
          helpers.docCookies.setItem(offerLocationsSearch.data('cookie-location'), offerLocation, 1500, '/');
        }
        if (offerType != null && offerType.length) {
          params['offer-type'] = offerType;
          offerTypesSearch.val(offerType);
          helpers.docCookies.setItem(offerTypesSearch.data('cookie-offer-type'), offerType, 1500, '/');
        }

        // Set cookie to url params
        if ((offerLocation == null && offerLocationCookie) || (offerType == null && offerTypeCookie)) {
          if (offerLocationsSearch.length && offerLocation == null && offerLocationCookie) {
            params['location'] = offerLocationCookie;
          }
          if (offerTypesSearch.length && offerType == null && offerTypeCookie) {
            params['offer-type'] = offerTypeCookie;
          }
        }

        // Push params to url
        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

        const handleUrlParamsOnInput = function() {
          const params = helpers.getParameters();

          if (offerLocationsSearch.length && offerLocationsSearch.val() !== '') {
            params['location'] = offerLocationsSearch.val();
          } else {
            delete params['location'];
          }
          if (offerTypesSearch.length && offerTypesSearch.val() !== '') {
            params['offer-type'] = offerTypesSearch.val();
          } else {
            delete params['offer-type'];
          }

          helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');
        };

        const submitButton = searchOffersForm.find('button[type="submit"]');

        searchOffersForm.find('.where, .offer')
          .on('input', function() {
            const _this = $(this);

            if (_this.val().length === 0) {
              handleUrlParamsOnInput();

              submitButton.prop('disabled', false);
            } else {
              submitButton.prop('disabled', true);
            }
          })
          .on('input_changed.rsd-ac', function() {
            handleUrlParamsOnInput();

            submitButton.prop('disabled', false);
          });

        // Trigger search on submit button clicked
        let timeout;
        submitButton.on('click', function(e) {
          e.preventDefault();

          clearTimeout(timeout);

          timeout = setTimeout(function() {
            handleOffersResults();

            document.dispatchEvent(helpers.initNewEvent(constants.EVENT_SUBMIT_CLICKED_SEARCH));
          }, 1000);
        });
      }

      const loadMoreButton = $('#global-offers-load-more-button');
      if (loadMoreButton.length) {
        loadMoreButton.on('click', function(e) {
          e.preventDefault();

          const offset = parseInt(offersWrapper.data('offset'), 10) || 0;

          handleOffersResults(offset);
        });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalOfferSearch.js